export const TERMS_AND_CONDITIONS_LINK =
  'https://www.idwell.at/terms-and-conditions'

export const GDPR_LINK = 'https://www.idwell.at/gdpr'
